import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router";
import { AnimatedBg } from "@/components/ds";

const Landing = lazy(() =>
  import("@/pages/Landing").then((module) => ({ default: module.Landing })),
);
const NotFound = lazy(() =>
  import("@/pages/NotFound").then((module) => ({ default: module.NotFound })),
);
const Login = lazy(() =>
  import("@/pages/admin/Login").then((module) => ({ default: module.Login })),
);
const AdminLayout = lazy(() =>
  import("@/pages/admin/AdminLayout").then((module) => ({
    default: module.AdminLayout,
  })),
);
const Dashboard = lazy(() =>
  import("@/pages/admin/Dashboard").then((module) => ({
    default: module.Dashboard,
  })),
);
const Accounts = lazy(() =>
  import("@/pages/admin/Accounts").then((module) => ({
    default: module.Accounts,
  })),
);

function RouteFallback() {
  return (
    <div className="mx-auto flex min-h-screen max-w-7xl items-center justify-center px-6">
      <div className="glass rounded-[var(--radius-lg)] px-6 py-4 text-sm font-medium text-[var(--color-fg-secondary)]">
        화면 불러오는 중
      </div>
    </div>
  );
}

export function App() {
  return (
    <>
      <AnimatedBg />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="accounts" element={<Accounts />} />
            <Route path="*" element={<NotFound admin />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}
